import { FC } from 'react'

import { SeoMeta } from '../../../components/SeoMeta'
import { ProductWithAvailability } from '../../../types/graphql'

import { BulkBag } from './BulkBag'
import { BulkFetchMore } from './BulkFetchMore'
import { BulkHero } from './BulkHero'
import { CategoryProductSection } from './CategoryProductSection'
import { BulkContainer } from './containers/BulkContainer'
import { GenderNav } from './GenderNav'
import { BulkSkeleton } from './Skeleton/BulkSkeleton'
import { CategoryContainer } from './styles'

import type { CollectionViewHeroSection } from './types'

type Props = {
  title: string | null
  description: string | null
  image: string | null
  heroSection: CollectionViewHeroSection
  noindex: boolean
}

export const BulkView: FC<Props> = ({ title, description, image, heroSection, noindex }) => {
  const { categorizedData } = BulkContainer.useContainer()

  return (
    <CategoryContainer>
      <SeoMeta
        title={title ?? undefined}
        description={description ?? undefined}
        image={image ?? undefined}
        noindex={noindex}
      />
      <BulkHero data={heroSection} />
      <GenderNav />
      {categorizedData.length === 0 ? (
        <BulkSkeleton />
      ) : (
        <>
          {categorizedData.map(category => (
            <CategoryProductSection
              key={category.value}
              headline={category.ctaText!}
              // TODO: Fix once useSelectVariant accepts generics
              products={category.products as unknown as ProductWithAvailability[]}
              name={category.value!}
            />
          ))}
        </>
      )}

      <BulkFetchMore />
      <BulkBag />
    </CategoryContainer>
  )
}
